// HOOKS
import { createContext, useState } from "react";

export const SelectedOrderedPartsContext = createContext({
  selectedOrderedParts: [],
  setSelectedOrderedParts: () => {},
  resetSelectedOrderedParts: () => {},
  removeSelectedOrderedPart: () => {},
  addSelectedOrderedPart: () => {},
});

export const SelectedOrderedPartsProvider = ({ children }) => {
  const [selectedOrderedParts, setSelectedOrderedParts] = useState([]);

  const resetSelectedOrderedParts = () => {
    setSelectedOrderedParts([]);
  };

  const removeSelectedOrderedPart = (_id) => {
    setSelectedOrderedParts(
      selectedOrderedParts.filter((part) => part._id !== _id)
    );
  };

  const addSelectedOrderedPart = (part) => {
    setSelectedOrderedParts([...selectedOrderedParts, part]);
  };

  return (
    <SelectedOrderedPartsContext.Provider
      value={{
        selectedOrderedParts,
        setSelectedOrderedParts,
        resetSelectedOrderedParts,
        removeSelectedOrderedPart,
        addSelectedOrderedPart,
      }}
    >
      {children}
    </SelectedOrderedPartsContext.Provider>
  );
};
